import { CREATE_WALLET_FAILURE, CREATE_WALLET_REQUEST, CREATE_WALLET_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const createWalletData = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_WALLET_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case CREATE_WALLET_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case CREATE_WALLET_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default createWalletData;
